var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isShowing
    ? _c(
        "div",
        {
          staticClass: "comment-reply",
          class: { "comment-reply--focus": _vm.isActive },
          attrs: { id: _vm.idSelector }
        },
        [
          _vm.isActive
            ? _c("editor-content", {
                staticClass: "comment-reply__text comment-reply__text--focus",
                attrs: { editor: _vm.editor }
              })
            : _c(
                "div",
                {
                  staticClass: "comment-reply__text",
                  on: { click: _vm.activateForm }
                },
                [
                  _c("span", { staticClass: "comment-reply__placeholder" }, [
                    _vm._v("Написать комментарий")
                  ])
                ]
              ),
          _vm._v(" "),
          _vm.isActive
            ? _c(
                "div",
                {
                  staticClass:
                    "comment-reply__attaches comment-reply__attaches--focus"
                },
                [
                  _c("div", { staticClass: "comment-reply__attach-image" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "comment-reply__attach-gif" }),
                  _vm._v(" "),
                  !_vm.$isMobile()
                    ? _c(
                        "div",
                        { staticClass: "comment-reply__attach-emoji" },
                        [
                          _c("VueTwemojiPicker", {
                            on: { selected: _vm.addEmoji }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isActive
            ? _c(
                "div",
                {
                  staticClass:
                    "comment-reply__actions comment-reply__actions--focus"
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "comment-reply__cancel",
                      on: { click: _vm.cancel }
                    },
                    [_vm._v("\n            Отменить\n        ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "comment-reply__send",
                      on: { click: _vm.send }
                    },
                    [
                      _vm._v(
                        "\n            " + _vm._s(_vm.btnText) + "\n        "
                      )
                    ]
                  )
                ]
              )
            : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }